// extracted by mini-css-extract-plugin
module.exports = {"advantage":"_9e1425b4d3--advantage--IowMu","advantage__content":"_9e1425b4d3--advantage__content--SwNfc"};